export default __webpack_public_path__ + "static/media/address-guide-tablet.0e6907e8.png";